import React from 'react';
import PropTypes from 'prop-types';

import {
  FormHorizental,
} from '../../../fragments/forms';
import AuthorInput from './author-input';
import TitleInput from './title-input';
import JournalSearchBox from './journal-searchbox';
import RefYear from './refyear';
import PubMedID from './pubmed-id';
import NonPubmed from './non-pubmed';
import Publish from './publish';
import SubmitButton from './submitBtn';

import style from './style.css';


export default class ReferenceEdit extends React.Component {

  static propTypes = {
    reference: PropTypes.object.isRequired,
    readOnly: PropTypes.bool.isRequired,
    showError: PropTypes.bool.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  static defaultProps = {
    readOnly: false,
    showError: true,
  };

  render() {
    const {reference} = this.props;
    return (
      <div>
        <FormHorizental className={style.reference} key={reference? reference.uuid : ''}>
          <PubMedID {...this.props} />
          <AuthorInput {...this.props} />
          <TitleInput {...this.props} />
          <JournalSearchBox {...this.props} />
          <RefYear {...this.props} />
          <NonPubmed {...this.props} />
          <hr/>
          <div className={style.submit}>
            <Publish {...this.props} />
            <SubmitButton {...this.props} />
          </div>
        </FormHorizental>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/reference/reference-edit/index.js